import MenHealthCart from "../../components/cart/menHealthCart";
import CompareTest from "../../components/compareTest/compareTest";
import Cookies from "js-cookie";
import HealthCare from "../../components/healthcare/healthcare";
import Work from "../../components/howItsWork/works";;
import Questions from "../../components/questions/question";
import Testimonial from "../../components/testimonial/testimonial";
import Reveal from "react-reveal/Reveal";
import HomeInsurance from "../../components/insuranceNotice/insurance";
import Fade from "react-reveal/Fade";
import { plans } from "../../data/health/men/cart.json";
import { healthcareData } from "../../data/health/men/healthCare.json";
import { questions } from "../../data/health/men/menHealthQuestions.json";
import { compare } from "../../data/landingPage/stdCompare.json";
import { menHealthData } from "../../data/health/men/menHealthStd.json";
import HomeStd from "../../components/LandingPage/stdMainMen";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import CartBar from "../../components/carts/cartBar";
import { mainQuery, MenJson } from "../../components/queryParam/query";
import Banner from "../../components/panelBanner/panelBanner";
import NeedWEb from "../../components/whyNextmed/needWeb";
import Benefits from "../../components/pr/sectionMen";

import { StdJson } from "../../components/queryParam/query";
// import pidData from "../../data/csv/pid_loc.json";

import pidData from "../../data/csv/pidJson.json";
import pidZipData from "../../data/csv/ziptoCsv.json";
import HomeLogo from "../../components/home-logos/homeLogo";
import { NextSeo } from "next-seo";
const MenHealth = (props) => {
  const router = useRouter();
  const [closeCart, setCloseCart] = useState(false);
  const [myCart, setMyCart] = useState([]);
  const [price, setPrice] = useState(0);
  const [group, setGroup] = useState(null);
  const [pidName, setPidName] = useState(null);
  const [dki, setDki] = useState(null);
  let totalPrice;


  const goToCheckout = (cart) => {
    FreshworksWidget("hide");
    let payload = {
      testImg: cart.img,
      cartName: cart.name,
      cartPrice: cart.price.toFixed(2),
      cartType: cart.type,
      month: cart.month,
      show_price: cart.show_price
    };
    myCart.push(payload);
    Cookies.set("cart", myCart);
    let getPrecent = (cart.price / 100) * 30;
    Cookies.set("discount", getPrecent);
    Cookies.set("totalPrice", cart.price.toFixed(2));
    window.location.href = "/checkout";
  };
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  useEffect(() => {
    const generate_id = () => {
      let a = Math.round(new Date() / 1000).toString();

      let b = randomIntFromInterval(1000000, 9999999).toString();

      return b + "_" + a;
    };
    let url = window.location.href.split("?");
    let main_url = url[0];
    let event_id = generate_id();
    window && window._learnq?.push([
      "track",
      "viewed product",
      {
        $event_id: event_id,
        PageUrl: main_url,
        lowest_price: ["$99"],
        testname: ["Male Hormone Standard"]
      },
    ]);
  }, [])
  const [home, setHome] = useState(null);
  useEffect(async () => {
    if (props && props.home != null) {
      if (props.home.toLowerCase() == "true") {
        Cookies.set("home", props.home);
        setHome(props.home)
      } else {
        Cookies.remove("home");
      }
    } else {
      Cookies.remove("home");
    }
    if (props.group && props.group != undefined) {
      FreshworksWidget("hide");
      Cookies.set("group", "true");
      const data = await StdJson(props.group);
      if (data) {
        setGroup(data);
      } else {
        setGroup(data);
      }
    } else {
      Cookies.remove("group");
    }
    if (props && props.quest != null) {
      Cookies.set("quest", props.quest);
    } else {
      Cookies.remove("quest");
    }
    if (props && props.pid != null) {
      let filterPid = pidData.find(
        (x) => x.Criteria_id.toString() == props.pid
      );
      if (filterPid) {
        if (filterPid.target_type == "Postal Code") {
          const getZip = pidZipData.find((x) => x.Zipcode == filterPid.Name);
          if (getZip) {
            Cookies.set("pid", getZip.Zipcode);
            setPidName(getZip.City);
          }
        } else {
          const ffZip = pidZipData.find((x) => x.City == filterPid.Name);
          Cookies.set("pid", ffZip.Zipcode);
          setPidName(filterPid.Name);
        }
      } else {
        const getZip1 = pidZipData.find((x) => x.Zipcode == props.pid);
        if (getZip1) {
          Cookies.set("pid", getZip1.Zipcode);
          setPidName(getZip1.City);
        } else {
          Cookies.remove("pid");
        }
      }
    }
    if (props && props.women != null && props.women.toLowerCase() == "true") {
      Cookies.set("women", props.women);
      document.documentElement.style.setProperty("--theme_color", "#FF799C");
    } else {
      Cookies.remove("women");
    }
    if (props && props.promo != null) {
      Cookies.set("promo", props.promo);
    } else {
      Cookies.remove("promo");
    }
    if (props && props.dki != null) {
      FreshworksWidget("hide");
      setDki(props.dki)
      Cookies.set("dki", props.dki);
    } else {
      Cookies.remove("dki");
    }
    Cookies.remove("reload")
    Cookies.set("path", window.location.href);
  }, []);
  return (
    <>
      <NextSeo
        title="Men's Health Test at Home | NextMed"
        description="Now you can book a test in your home or at a nearby lab in minutes. Receive doctor messaging, follow-ups, and discounted supplements"
        canonical="https://www.nextmed.com/menhealth#view-tests"
      />



      {/* <Navbar /> */}
      {closeCart == true && (
        <CartBar
          setPrice={setPrice}
          price={price}
          insurance={props.insurance}
          setInsuranceVal={props.setInsuranceVal}
          myCart={myCart}
          setMyCart={setMyCart}
          setCloseCart={setCloseCart}
          closeCart={closeCart}
        />
      )}
      <div className={closeCart == true ? "backdrop loader-active" : ""}></div>
      <Fade bottom duration={1000} distance={"50px"}>
        <HomeStd pidName={pidName} home={home} dki={dki} group={group} data={menHealthData} type="allergies" />
        <HomeLogo dki={dki} group={group} />
        <Work />
        <Banner />
        <MenHealthCart
          insurance={props.insurance}
          setInsuranceVal={props.setInsuranceVal}
          data={plans} pid={props.pid}
          goToCheckout={goToCheckout}
          dki={dki}
        />

        <Benefits />
        <HomeInsurance dki={props.dki} group={props.group} />
        <NeedWEb />
        {/* <NormalCost /> */}
        <HealthCare data={healthcareData} />
        {/* <Testimonial /> */}
        {/* {window.location.href.includes("?") ? <Partners /> : ""} */}
        {/* <Partners /> */}
        <Questions questions={questions} />
        <CompareTest data={compare} type="std" />
      </Fade>
    </>
  );
};
export default MenHealth;
export async function getServerSideProps(context) {
  const data = context.query;
  return {
    props: {
      home: data.home ? data.home : null,
      group: data.group ? data.group : null,
      quest: data.quest ? data.quest : null,
      pid: data.pid ? data.pid : null,
      women: data.women ? data.women : null,
      dki: data.dki ? data.dki : null,
      promo: data.promo ? data.promo : null,

    }, // will be passed to the page component as props
  };
}